import { InputAdornment, TextField } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Search } from 'lucide-react'
import { ComponentProps, KeyboardEvent } from 'react'
import { useIntl } from 'react-intl'
import { SearchInputStyles } from './styles'

type searchInputProps = {
    onChange: (value: string) => void
    onSubmit: () => void
} & Omit<ComponentProps<typeof TextField>, 'onChange' | 'onSubmit'>
export const SearchInput = ({ value, onChange, onSubmit, ...rest }: searchInputProps): React.ReactElement => {
    const intl = useIntl()

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        onChange(event.target.value)
    }

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>): void => {
        if (event.key === 'Enter') {
            event.preventDefault()
            onSubmit()
        }
    }

    return (
        <div role="search">
            <TextField
                size="small"
                value={value}
                onKeyDown={handleKeyDown}
                onChange={handleChange}
                placeholder={intl.formatMessage({
                    id: 'components_search-inputSearch',
                    defaultMessage: 'Search',
                })}
                inputProps={{ 'aria-label': 'search' }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end" sx={SearchInputStyles.searchIcon}>
                            <C1Icon icon={Search} size="sm" />
                        </InputAdornment>
                    ),
                }}
                sx={{
                    '.MuiInputBase-root.MuiOutlinedInput-root': {
                        maxHeight: '30px',
                    },
                }}
                {...rest}
            />
        </div>
    )
}

export default SearchInput
